/** 归一化后端存库的附件路径，兼容缺省 /uploads 前缀的历史数据 */
export function normalizeUploadPath(relativePath) {
  if (!relativePath) return '';
  const text = String(relativePath).replace(/\\/g, '/').trim();
  if (/^https?:\/\//i.test(text)) return text;
  if (text.startsWith('/uploads/')) return text;
  if (text.startsWith('/hr/')) return `/uploads${text}`;
  if (text.startsWith('hr/')) return `/uploads/${text}`;
  if (text.startsWith('uploads/')) return `/${text}`;
  if (text.startsWith('expense/')) return `/uploads/${text}`;
  if (!text.startsWith('/')) return `/uploads/hr/onboarding/${text}`;
  return text;
}

/**
 * 将后端返回的 /uploads/... 路径转为浏览器可访问的完整 URL。
 * 开发环境下前端 3007 的 /uploads 代理常未生效，静态资源需直连后端 3006。
 */
export function resolveUploadUrl(relativePath) {
  if (!relativePath) return '';
  if (/^https?:\/\//i.test(relativePath)) return relativePath;
  const path = normalizeUploadPath(relativePath);
  const apiBase = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

  if (/^https?:\/\//i.test(apiBase)) {
    return `${apiBase.replace(/\/api$/, '')}${path}`;
  }

  if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    const { hostname, protocol } = window.location;
    const backendPort = process.env.REACT_APP_BACKEND_PORT || '3006';
    return `${protocol}//${hostname}:${backendPort}${path}`;
  }

  return path;
}

export function isImageUploadPath(filePath) {
  return /\.(png|jpe?g|gif|webp|bmp)$/i.test(filePath || '');
}

export function isPdfUploadPath(filePath) {
  return /\.pdf$/i.test(filePath || '');
}

export function isDocxUploadPath(filePath) {
  return /\.docx$/i.test(filePath || '');
}

/** 旧版 Word 二进制格式，浏览器无法直接渲染 */
export function isLegacyDocUploadPath(filePath) {
  return /\.doc$/i.test(filePath || '') && !/\.docx$/i.test(filePath || '');
}
